import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";

// TODO lacks dateFormat
export function DurationForm() {
    const { isFormDisabled, form } = useFieldFormContext();

    return (
        <div className="p-0">
            <FormField
                name="field_date_options.durationFormat"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel>
                            Duration Format
                        </FormLabel>
                        <Select onValueChange={field.onChange} value={field.value} disabled={isFormDisabled}>
                            <FormControl>
                                <SelectTrigger autoComplete="off">
                                    <SelectValue placeholder="Select duration format" />
                                </SelectTrigger>
                            </FormControl>
                            <SelectContent>
                                {['h:mm', 'h:mm:ss', 'h:mm:ss.s', 'h:mm:ss.ss', 'h:mm:ss.sss'].map(format => (
                                    <SelectItem key={format} value={format}>{format}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
}